import gsap from "gsap";

export default class SelectVariantsMobile {
  constructor() {
    this.isOpen = false;
    this.openInfoButton = document.querySelector('[data-js="product-atc"]');
    this.productInfo = document.querySelector(
      '[data-js="product-mobile-info"]',
    );
  }

  init() {
    this.openInfoButton.addEventListener("click", (e) => {
      this.open();
    });

    document.addEventListener("click", (e) => {
      this.clickOutside(e);
    });
  }

  open() {
    if (window.innerWidth < 1024) {
      gsap.set(this.productInfo, { autoAlpha: 0 });
    }

    this.isOpen = true;
    this.productInfo.classList.remove("max-lg:hidden");

    if (window.innerWidth < 1024) {
      gsap.to(this.productInfo, {
        autoAlpha: 1,
        duration: 0.3,
      });
    }
  }

  close() {
    this.isOpen = false;

    if (window.innerWidth < 1024) {
      gsap.to(this.productInfo, {
        autoAlpha: 0,
        duration: 0.3,
        onComplete: () => {
          this.productInfo.classList.add("max-lg:hidden");
        },
      });
    } else {
      this.productInfo.classList.add("max-lg:hidden");
    }
  }

  clickOutside(e) {
    if (
      !this.productInfo.contains(e.target) &&
      !this.openInfoButton.contains(e.target)
    ) {
      this.close();
    }
  }
}
